import {
  FacebookFilled,
  InstagramOutlined,
  TwitterOutlined,
} from '@ant-design/icons';
import moment from 'moment';

export const socmedType = {
  FB_ADS: 1,
  FB_PAGES: 2,
  IG: 4,
  TWT: 3,
};

export const socmedTypeIcon = {
  FB: <FacebookFilled style={{ color: '#0E4FF4' }} />,
  IG: <InstagramOutlined style={{ color: '#C3369C' }} />,
  TWT: <TwitterOutlined style={{ color: '#0ECBF4' }} />,
};

export default socmedType;

export const facebookBreakdowns = [
  [],
  ['age'],
  ['gender'],
  ['age', 'gender'],
  ['country'],
  ['impression_device'],
  ['device_platform'],
  ['region'],
  ['platform_position', 'publisher_platform'],
  // ['publisher_platform', 'platform_position', 'impression_device'],
  ['publisher_platform'],
  ['publisher_platform', 'impression_device'],
];

export const facebookFields = [
  'adset_name',
  'campaign_name',
  'ad_name',
  // 'ad_id',
  // 'adset_id',
  // 'campaign_id',
  'reach',
  'cpm',
  'cpc',
  'ctr',
  'clicks',
  'impressions',
  'spend',
];

export const socmedTypeList = [
  {
    value: socmedType.FB_ADS,
    text: 'Facebook',
    label: 'Facebook Ads',
    icon: socmedTypeIcon.FB,
    id: 1,
    acronym: 'FB',
    analyzerFields: 'facebook_fields',
    type: 'fb',
    analyzerBody: ({ startDate, endDate, adId, breakdowns }) => {
      return {
        breakdowns,
        fields: facebookFields,
        since: startDate,
        until: endDate,
        ad_id: adId,
      };
    },
  },
  {
    value: socmedType.FB_PAGES,
    text: 'Facebook',
    label: 'Facebook Pages',
    acronym: 'FB',
    icon: socmedTypeIcon.FB,
    id: 2,
    analyzerFields: 'facebook_fields',
    type: 'fb-page',
    analyzerBody: ({ startDate, endDate, adId }) => {
      return {
        fields: facebookFields,
        since: startDate,
        until: endDate,
        ad_id: adId,
      };
    },
  },
  {
    value: socmedType.IG,
    text: 'Instagram',
    label: 'Instagram',
    icon: socmedTypeIcon.IG,
    id: 4,
    acronym: 'IG',
    analyzerFields: 'instagram_fields',
    type: 'ig',
    analyzerBody: () => {
      return {};
    },
  },
  {
    value: socmedType.TWT,
    text: 'Twitter',
    label: 'Twitter',
    icon: socmedTypeIcon.TWT,
    id: 3,
    acronym: 'TW',
    analyzerFields: 'twitter_fields',
    type: 'twitter',
    analyzerBody: ({ startDate, endDate, entityId }) => {
      const parsedStartDate = moment(startDate);
      const parsedEndDate = moment(endDate);
      const formattedDate = {
        minute: 0,
        second: 0,
        millisecond: 0,
      };
      parsedStartDate.set(formattedDate);
      parsedEndDate.set(formattedDate);
      return {
        entity: 'CAMPAIGN',
        entity_ids: entityId,
        granularity: 'TOTAL',
        metric_groups: 'ENGAGEMENT,BILLING',
        placement: 'ALL_ON_TWITTER',
        start_time: parsedStartDate.toISOString(),
        end_time: parsedEndDate.toISOString(),
      };
    },
  },
];
